export enum TopicShareType {
  private = 1,
  public = 2,
}
